let viewed_products =JSON.parse(localStorage.getItem('ViewedProductsWoodTrick'));
if(viewed_products != null && viewed_products.length > 1){
    viewed_products.forEach((item, index)  => {
        fetch(`${window.routes.product}/${item}?section_id=ajax-product-card`).then(function (response) {
            return response.text();
        }).then(function (html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            let card = doc.querySelector('.carousel-card');
            let slider_item = document.createElement("div");
            $(slider_item).addClass('carousel-box__item')
            $(slider_item)[0].innerHTML = card.outerHTML;
            $('.js-viewed-product-list').append(slider_item);
        }).catch(function (err) {
            console.error('Something went wrong.', err);
        });
    });
}else{
    $('.js-viewed-product').hide()
}
$('.js-viewed-product-list').on('DOMSubtreeModified',function (){
    let item_length = $(this).find('.carousel-box__item').length;
    if(item_length == viewed_products.length){
        $(this).addClass('carousel-box__list')
        initViewedSlider();
        $('.js-viewed-product').show()
    }
})
function initViewedSlider(){
    var $block = $('.js-viewed-product');
    var $slider = $block.find('.js-viewed-product-list');
    var $sliderItem = $block.find('.carousel-box__item');
    var countValue = $sliderItem.length;
    var prevArrow = '<button type="button" class="slick-prev"><span class="slick-arrow-icon icon-arrow-left"></span></button>';
    var nextArrow = '<button type="button" class="slick-next"><span class="slick-arrow-icon icon-arrow-right"></span></button>';
    var settings = {};
    var ViewedSlider = function ViewedSlider() {
        if (countValue > 1) {
            if ($block.hasClass('carousel-box_styled')) {
                settings = {
                    slidesToShow: 2.3,
                    slidesToScroll: 1,
                    arrows: true,
                    prevArrow: prevArrow,
                    nextArrow: nextArrow,
                    dots: true,
                    infinite: false,
                    responsive: [{
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1
                        }
                    }]
                };
            } else {
                settings = {
                    slidesToShow: 4,
                    slidesToScroll: 2,
                    arrows: true,
                    prevArrow: prevArrow,
                    nextArrow: nextArrow,
                    dots: true,
                    centerMode: false,
                    responsive: [{
                        breakpoint: 1240,
                        settings: {
                            slidesToShow: 3,
                            centerMode: false
                        }
                    }, {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2.5,
                            slidesToScroll: 1,
                            centerMode: false,
                            dots: false,
                            infinite: false
                        }
                    }, {
                        breakpoint: 540,
                        settings: {
                            slidesToShow: 1.5,
                            slidesToScroll: 1,
                            centerMode: false,
                            dots: false,
                            infinite: false
                        }
                    }]
                };
            }
            $slider.not('.slick-initialized').slick(settings);
        }
    };
    ViewedSlider()
    var ViewedSliderChildHeightUpd = function ViewedSliderChildHeightUpd() {
        var $slickSlide = $block.find('.slick-slide');
        $slickSlide.children().css('height', '100%');
    };
    $slider.on('init', function () {
        ViewedSliderChildHeightUpd();
    });
    $(window).on('resize',ViewedSlider);
}